/* ---------------------------------------------------------------------------------------------------------------------
   TSC COMPARE

   Drives the "pick two scooters" card row and the spec table under it. Every scooter's copy and numbers are printed
   into the page as JSON by the section, so a pick is a DOM update and never a request.
   --------------------------------------------------------------------------------------------------------------------- */

(function () {
  var MAX_PICKS = 2;
  var MIN_PICKS = 1;

  function initCompare(root) {
    // Sections get re-rendered in the theme editor, and the DOMContentLoaded and readyState paths below can both fire
    // for the same element, so binding is guarded rather than assumed to happen once.
    if (root.dataset.tscCompareReady === "true") return;
    root.dataset.tscCompareReady = "true";

    var dataEl = root.querySelector("[data-tsc-compare-data]");
    if (!dataEl) return;

    var models;
    try {
      models = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }
    if (!Array.isArray(models) || models.length === 0) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-cmp-card]"));
    if (cards.length === 0) return;

    var versusEls = root.querySelectorAll("[data-cmp-versus]");
    var rows = Array.prototype.slice.call(root.querySelectorAll("[data-cmp-row]"));
    // The three labels are section settings, carried on the root rather than inferred from the cards: a section with
    // only two scooters starts with both picked, so no card would be showing the unpicked wording to copy.
    var emptyLabel = root.dataset.emptyLabel || "";
    var pickedLabel = root.dataset.pickedLabel || "";
    var unpickedLabel = root.dataset.unpickedLabel || "";

    // Picks are held oldest first, which is what makes a third tap replace the one that has been on screen longest.
    var picked = [];
    cards.forEach(function (card, index) {
      if (card.getAttribute("aria-pressed") === "true" && picked.length < MAX_PICKS) {
        picked.push(index);
      }
    });

    function modelAt(slot) {
      var index = picked[slot];
      if (index === undefined) return null;
      return models[index] || null;
    }

    function renderColumn(slot) {
      var model = modelAt(slot);
      var head = root.querySelector('[data-cmp-head="' + slot + '"]');
      var foot = root.querySelector('[data-cmp-foot="' + slot + '"]');

      if (head) {
        var name = head.querySelector("[data-cmp-name]");
        var price = head.querySelector("[data-cmp-price]");
        var blurb = head.querySelector("[data-cmp-blurb]");

        if (name) name.textContent = model ? model.name || "" : emptyLabel;
        if (price) price.textContent = model ? model.price || "" : "";
        if (blurb) blurb.textContent = model ? model.blurb || "" : "";
      }

      if (foot) {
        var shop = foot.querySelector("[data-cmp-shop]");
        if (shop) {
          // A scooter with no link of its own would otherwise leave a button that goes nowhere.
          if (model && model.url) {
            shop.href = model.url;
            shop.textContent = model.cta || model.name || "";
            shop.hidden = false;
          } else {
            shop.hidden = true;
          }
        }
      }
    }

    function renderRows() {
      var left = modelAt(0);
      var right = modelAt(1);
      var visibleRows = 0;

      rows.forEach(function (row) {
        var rowIndex = parseInt(row.dataset.cmpRow, 10) - 1;
        var values = [left, right].map(function (model) {
          if (!model || !Array.isArray(model.values)) return "";
          return model.values[rowIndex] || "";
        });

        // A row neither picked scooter has a number for is noise, so it leaves rather than showing two blanks.
        var hide = values[0] === "" && values[1] === "";
        row.hidden = hide;

        // Striping counts what is on screen, so hiding a row never leaves two tinted rows touching.
        if (!hide) visibleRows++;
        row.classList.toggle("is-alt", !hide && visibleRows % 2 === 0);

        values.forEach(function (value, slot) {
          var cell = row.querySelector('[data-cmp-cell="' + slot + '"]');
          if (!cell) return;

          var isEmpty = value === "";
          cell.textContent = isEmpty ? "—" : value;
          cell.classList.toggle("is-empty", isEmpty);
        });
      });
    }

    function renderVersus() {
      var names = [0, 1].map(function (slot) {
        var model = modelAt(slot);
        return model ? model.name || emptyLabel : emptyLabel;
      });

      var text = names.join(" vs ");
      versusEls.forEach(function (el) {
        el.textContent = text;
      });
    }

    function renderCards() {
      cards.forEach(function (card, index) {
        var isPicked = picked.indexOf(index) !== -1;
        card.setAttribute("aria-pressed", isPicked ? "true" : "false");

        var state = card.querySelector("[data-cmp-state]");
        if (state) state.textContent = isPicked ? pickedLabel : unpickedLabel;
      });
    }

    function render() {
      renderCards();
      renderColumn(0);
      renderColumn(1);
      renderRows();
      renderVersus();
    }

    function toggle(index) {
      var at = picked.indexOf(index);

      if (at !== -1) {
        // One pick is always kept. Emptying the table leaves a heading that reads "Pick a second model vs Pick a
        // second model" over a header row with nothing under it, and nothing on the page to undo. Keeping the last
        // pick also means only the second column is ever empty, which is what makes that wording true.
        if (picked.length > MIN_PICKS) picked.splice(at, 1);
      } else {
        // Two is the most the table can show, so the oldest pick steps aside rather than the tap doing nothing.
        if (picked.length >= MAX_PICKS) picked.shift();
        picked.push(index);
      }

      render();
    }

    cards.forEach(function (card) {
      card.addEventListener("click", function () {
        toggle(parseInt(card.dataset.index, 10));
      });
    });

    render();
  }

  function initAll(scope) {
    var target = scope && scope.querySelectorAll ? scope : document;
    target.querySelectorAll(".js-tsc-compare").forEach(initCompare);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
